import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { parse } from 'fast-xml-parser';
import { decode } from 'he';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { DecksService } from '../../decks/decks.service';
import { Card, Deck, InventoryCard } from '@deckplan.io/common';
import { map } from 'rxjs/operators';
import { InventoryService } from '../../inventory/inventory.service';
import { CardService } from '../../cards/card.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    public newsItems: any[] = [];
    public decks: Observable<Deck[]>;
    public publicDecks: Observable<Deck[]>;
    public cards: InventoryCard[];
    public popularCreatures: Observable<Card[]>;
    public popularArtifacts: Observable<Card[]>;
    public popularCommanders: Observable<Card[]>;
    public edhrecRankedCards: Observable<Card[]>;
    // eslint-disable-next-line no-magic-numbers
    public numberOfEdhrecRankedCards = 10;
    // eslint-disable-next-line no-magic-numbers
    public numberOfPublicDecks = 6;

    private readonly magicNewsURL = `${environment.apiUrl}/${environment.apiVersion}/wizards-rss`;
    // eslint-disable-next-line no-magic-numbers
    private readonly numberOfRecentDecks = 6;
    // eslint-disable-next-line no-magic-numbers
    private readonly numberOfRecentCards = 9;
    // eslint-disable-next-line no-magic-numbers
    private readonly numberOfPopularCards = 9;

    constructor(private readonly router: Router,
                private readonly http: HttpClient,
                private readonly sanitizer: DomSanitizer,
                private readonly decksService: DecksService,
                private readonly cardService: CardService,
                private readonly inventoryService: InventoryService) {}

    public ngOnInit() {
        this.http.get(this.magicNewsURL, {responseType: 'text', headers: {'x-requested-with': 'Angular 8+'}}).subscribe(feedStr => {
            const feed = parse(feedStr, {ignoreAttributes: false}, true);
            this.newsItems = feed.rss.channel.item.map(item => {
                item['dc:creator'] = this.decodeSafeString(item['dc:creator']);
                item.description = this.decode(item.description);
                return item;
            });
        });

        this.loadDecks();

        this.publicDecks = this.decksService.getPublic(null,
            {
                sort: {active: 'upvoteCount', direction: 'desc'},
                page: {pageSize: this.numberOfPublicDecks, pageIndex: 0}
            }
        ).pipe(map(decksWithTotalCount => decksWithTotalCount.decks));

        this.inventoryService.getInventory({
            pagination: {
                sort: {active: 'inventory.updated', direction: 'desc'},
                page: {pageSize: this.numberOfRecentCards, pageIndex: 0}
            },
            query: null
        }).subscribe(cardsAndCount => {
            this.cards = cardsAndCount.inventoryCards;
        });

        this.popularCreatures = this.cardService.getPopluarCardsByType('Legendary Creature', this.numberOfPopularCards);
        this.popularArtifacts = this.cardService.getPopluarCardsByType('Artifact', this.numberOfPopularCards);
        this.popularCommanders = this.decksService.getPopularCommanders(this.numberOfPopularCards);
        this.edhrecRankedCards = this.cardService.getTopEdhrec(this.numberOfEdhrecRankedCards);
    }

    public decode(value: string) {
        return this.sanitizer.bypassSecurityTrustHtml(decode(value).replace('href="/en/',
            'target="_blank" gtagEvent trackOn="click" action="read_more" category="magic_feed" href="https://magic.wizards.com/en/'));
    }

    public decodeSafeString(value: string) {
        return decode(value);
    }

    public deleteDeck(deck: Deck) {
        this.decksService.delete(deck.id)
            .subscribe(() => this.loadDecks());
    }

    private loadDecks(): void {
        this.decks = this.decksService.getAll(null, {page: {pageIndex: 0, pageSize: this.numberOfRecentDecks}, sort: {active: 'deck.updated', direction: 'desc'}}).pipe(
            map(decksWithTotalCount => decksWithTotalCount.decks)
        );
    }
}
